import Vue from "vue";

const registerGlobalComponents = () => {
  // Lazy-loaded components
  Vue.component("PatientProfile", () => import("@/components/PatientProfile"));
  
  // Error handling components
  Vue.component("ErrorBoundary", () => import("@/components/ErrorBoundary"));
};

export default registerGlobalComponents;